import { IGroup } from "@grassrootly/api";
import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";
import { NavigationProp } from "@react-navigation/native";
import { MainStackParamList } from "../../../navigation/Navigation.types";

export interface EditGroupProps {
  group: IGroup;
  onEditFinished: () => void;
  navigation?: NavigationProp<MainStackParamList>;
}

export interface IEditGroupForm {
  name: string;
  join_code: string;
}

export const groupForm: FormBuilderType<IEditGroupForm> = {
  name: {
    type: "input",
    name: "name",
    label: "Name",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
    },
  },
  join_code: {
    type: "input",
    name: "join_code",
    label: "Join Code",
    disabledIf: () => true,
    defaultValue: "",
    validators: [FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
      selectTextOnFocus: true,
      editable: false,
    },
  },
};
